

import { useState,useEffect } from "react";
// import Register from "../../Components/Register/Register";
import "./Transact.css"
// import useAuth from "../../Hooks/UseAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BeatLoader from "react-spinners/BeatLoader";

import { faHome,faClipboard,faChartLine,faChevronDown,faUserShield } from '@fortawesome/free-solid-svg-icons'
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";


function Transact(){  
  
    const options = ["Allowance","Deduction","Deduction Repayment"];
    // const options = ["Allowance","Deduction","Advance Request","Advance Repayment"];
    const [deposit,setDepsit] =useState(true); 
    const [withdraw,setWithdraw] =useState(false); 
    // const [TID,setTID] = useState(); 
    const [tidType,setType] = useState(); 
    const [rid,setRID] = useState(); 
    const [amount,setAmount] =useState(); 
    const [notes,setNotes] = useState(); 
    const [accno,setAccNo] = useState(); 
    const [dropState,setDropState] =useState(false); 
    const [selected,setSelected] = useState("Select Transaction Type"); 
    const [successMsg,setSuccessMsg] = useState(false); 
    const [errorMsg,setErrorMsg] = useState(false); 
    const [Msg,setMsg] = useState(""); 
    const [errorMsgLit,setErrorMsgLit] = useState(""); 
    const [Loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [UID, setUID] = useState('');
    const [name, setName] = useState('')
    const [searchData, setSearchData] = useState(""); 
    const [fildata, setFildata] = useState([]); 
    const[tData, setTData] = useState([]);
    const [userData, setUserData] = useState([]); 
    const [users, setUsers] = useState();
    const axiosPrivate = useAxiosPrivate();
    const auth = useAuth()
        // const [Ssn, setSsn] = useState("");

    

    // const {auth} = useAuth(); 
    // const [Branch,setBranch] = useState(auth.dat.Branch); 
    
    // console.log("BRanch",auth.dat.Branch)

    const handleSelect = () =>{ 
         
        setDropState(!dropState); 
    }

    const valFunc = (event) => { 
        
        event.preventDefault();
        if(selected =="Select Transaction Type"){
            setErrorMsg(true);
            setMsg("Select Transaction type ")
        }else if((amount=="")||(accno=="") ||(rid =="")){

            setErrorMsg(true);
            setMsg("Fill all fields ")
        }else if((accno.length < 10)|| (rid.length < 10)){
            setErrorMsg(true);
            setMsg("Invalid credentials")
        }else{

            handleSubmit();
        }

        
    }


    // async function handleSubmit(event) {
	// 	event.preventDefault();
    //     console.log("Type:",tidType,)
    //     setLoading(true);


	// 	// const req = await fetch('https://superagentback.onrender.com/api/addtransaction', {
	// 	const req = await fetch('https://nerdayb.onrender.com/api/addtransaction', {
	
	// 		method: 'POST',
    //         headers: { 
    //             "content-type" :   "application/json"
    //            }, 
		
	// 		body: JSON.stringify({
	// 			tidType,
    //             rid,
    //             accno,
    //             amount,
    //             notes,
                
	// 		}),
	// 	})
      

	// 	const data = await req.json();
    //     if(data.status== "Ok"){ 
    //         setLoading(false);
    //         setAmount("");
    //         setAccNo("")
    //         setRID("")
    //         setSelected("Select Transaction Type");
    //         setSuccessMsg(true);
    //         // console.log(auth)
            
        
    //     }else{
    //         setLoading(false);
    //         setErrorMsg(true);
    //         setMsg(data.msg)
    //         setErrorMsgLit(data.error);
    //     }
    //     console.log("Data here", data)
		
	// } 

    

    // Status Message  Timeout
    setTimeout(() => {
        setSuccessMsg(false);
        setErrorMsg(false); 
    }, 12001);

    const handleFilter = (event) =>{ 
        // console.log(event.target.value);
        const searchWord = event.target.value;
        const newFilter = searchData.filter((value)=>{
            // console.log("searchWord",searchWord)
             return value.name.toLowerCase().includes(searchWord.toLowerCase());
              
        })

        setFildata(newFilter);
   }

   

   

    async function populateData(){  

        // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
        const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
            headers : { 
           
            }
       
        })
        
        const data = await response.json();
        console.log("All Data here",data.propdata)
        if(data){

    if(data.status == "ok") {
        setTData(data.propdata)
        setSearchData(data.propdata)
        // console.log("Data here",data)
        }else{
        //    alert(data.error,"Here!")
        // console.log("testign first")
        } 

    }
    

    
    return data;
    
} 

async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);


    /////
    const req = await axiosPrivate.post("/txns",
    //  const response = await axiosPrivate.post("http://localhost:2000/users",
        JSON.stringify({
            tidType,
            // rid,
            // email : auth.user,
            // Branch,
            // accno,
            // amount,
            // 			tidType,
                rid,
                accno,
                amount,
                notes,
                UID,
                UIDSEC: auth.auth.foundUser._id,
                
           
         }),
        // JSON.stringify({ user, pwd }),
        {
            headers: { 'Content-Type': 'application/json',
           
         },
            
            withCredentials: true,
            crossDomain: true,
            
        }
    );

    ////

    const data = await req;
    if(data.data.status== "Ok"){ 
        setLoading(false);
        setAmount("");
        setAccNo("")
        setRID("")
        setSelected("Select Transaction Type");
        setSuccessMsg(true);
        // console.log(auth)
        
    
    }else{
        setLoading(false);
        setErrorMsg(true);
        setMsg(data.msg)
        setErrorMsgLit(data.error);
    }
    // console.log("Data here", data)
    
}

// useEffect(()=>{ 

//  populateData();
//  console.log("test populate");

// },[]) 

useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
        try {
            const response = await axiosPrivate.get('/users', {
                signal: controller.signal,
                params: {
                
                    Org: auth.auth.foundUser.Org,
                    // org: 'value2',
                    // mgtLvl: 'value2',
                  }
            });
            // console.log(response.data);
            // console.log("Heresummary");
            isMounted && setUsers(response.data);
            // setTData(response?.data)
            setSearchData(response?.data)
        } catch (err) {
            console.error(err);
          //   navigate('/login', { state: { from: location }, replace: true });
        }
    }
    console.log("contect",auth)
    getUsers();

    return () => {
        isMounted = false;
        controller.abort();
    }
}, [])

const handleSelected = (item) =>{

        // console.log("herezz",item)
        setUserData(item)

        // console.log("User",userData)

        // name,
        // email,
        // Gender,
            setName(item.name);
            setEmail(item.email);
            // setGender(item.Gender);
            // setPosition(item.Position);
            setAccNo(item.AccountNo);
            setUID(item._id)
            // setGender(item.Gender);
            // setMgtLevl(2);
            // setAddress("");
            // setCompensation(item.Base_Pay);
            // setSsn(item.Ssn);
            // setEmail(item.email);
            // setAccountBranch(item.AccountBranch);
            // setAddress(item.Home_address);
            // setFInstitutionn(item.FInstitution); 
            // setDoh(item.Hire_Date);
            // setNik(item.NextofKin);
            // setNikAddress(item.NextofKinAddress);
            // setNikRel(item.NextofKinRel);
            // setNikContact(item.NextofKinContact);
            // setAccountType(item.AccountType);
            // setDoh(item.Hire_Date);
        

}
    

    return( 

        <>   
         <div className="justCover">

         <div className="searchCover">
                  {/* input field */}
            <div className='searchBar'>  
          
                    <div className='searchInputs'>
                        <input type="text" name='Locat' onChange = {handleFilter} />
                        <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

                        { 
                        fildata.length > 0 && 
                        (

                        <div className='dataResults'>
                        {
                        searchData && 
                        
                        fildata.map((index,key)=>{
                            
                            return (
                            <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                            
                            )
                        
                        })} 
                    
                    </div>


                        )
                    }

                    </div>
                    </div>

            </div> 
            {/* End of search cover */}

            <div className="payReport">
                                {/* <div className="prHeading">
                                        <div><p><b>Payslip</b></p></div>
                                        <div><p>Payment slip for the month of Janury 2021</p></div>
                                </div> */}
                                <div className="empDetailsContainers">
                                    <div className="empDetails">
                                        <div><p><b>Employee Name:</b></p></div>
                                        <div><p>{userData.name}</p></div>
                                    </div>
                                    <div className="empDetails">
                                        <div><p><b>NRC:</b></p></div>
                                        <div><p>{userData.Ssn}</p></div>
                                    </div>
                                    <br/>
                                    {/* <div className="empDetails">
                                        <div><h3>Designation:</h3></div>
                                        <div><p>Chef</p></div>
                                    </div> */}


                                


                                </div>
                            

                            </div>
           <div className="transactCoverzz">

            

           <form onSubmit={handleSubmit}>   
           {/* <form onSubmit={valFunc}>    */}
           
                                    
                                    <div className="textEntry">
                                    
                                        <div className='inputGroupa'>  

                        {/* TRANSACTION INPUT FIELDS*/}

                        <div className='dropContainer'>

                       

                    
                                <div className='categoryButton'  onClick={handleSelect} >

                                      <div> <p>{selected}</p> </div>  
                                      <div> <FontAwesomeIcon icon={faChevronDown} className="FontAwesomeIcon"/></div>

                                </div>
                                       
                                { dropState && <div className='dropDownList'>      
                                                                                         
                                                                       
                                                       { options.map((item,key)=>{
                                                       
                                                          return(
                                                                <div  name="Industry" 
                                                                                    // onChange={handleChange} 
                                                                                    value={selected} onClick={e => {
                                                                                    setSelected(item);
                                                                                    setType(item);
                                                                                    setDropState(false);
                                                                                    console.log("select",selected)
                                                                                  
                                                               
                                                                }}
                                                             
                                                             
                                                             
                                                             key={item} className='dropDownItem'>
                                                                   <p>{item}</p>
                                                              </div>
                                                          )})        

                                                        }

                                               </div>                                                                                                                        

                                      }
                               

                   

                        </div>

                       </div>
                   

                 </div>
                                      
                                    {/* Account No */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="text"
                                            value={notes} 
                                            // minlength="10"
                                            // maxlength="10" 
                                            required
                                            onChange={(e)=>{setNotes(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>Note</label>

                                    </div>
                                    {/* Account No */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="text"
                                            value={accno} 
                                            min="1"
                                            required
                                            disabled
                                            // minlength="10"
                                            // maxlength="10"
                                             
                                            
                                            onChange={(e)=>{setAccNo(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>User</label>

                                    </div>
                                    {/* Amount */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="number"
                                            value={amount} 
                                            min="1"
                                            
                                            onChange={(e)=>{setAmount(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>Amount</label>

                                    </div>
                                    {successMsg && <div className="successMsgContainer">
                                            
                                                <p>{`Transaction successful!`}</p>
                                        </div>}
                                    {errorMsg && <div className="errorMsgContainer">
                                            
                                                <p>{`Transaction Failed! ${Msg}`}</p>
                                                
                                        </div>}

                                        {/* Loading Animation */}
                                        {Loading ?
                                        <div>
                                            <BeatLoader color="#36d7b7" />
                                        
                                        </div> :  
                                            <>
                                                <div className="submitBtn">
                                                    <button type="submit">Submit</button>
                                                 </div>    
                                             
                                            </>   
                                        
                                        } 
                             
                               
                                </form>

        
               
                
               
           </div>

         </div>


           
        </>
    )

}

export default Transact;


